export interface Data {
    id: number;
    title: string;
    jenis_pengetahuan: string;
    is_klinik_khusus: boolean;
    tipe_klinik_khusus: string;
    jadwal_mulai: string;
    jadwal_selesai: string;
    count_status_tte_belum: number;
    count_status_tte_proses: number;
    count_status_tte_gagal: number;
    count_status_tte_selesai: number;
    count_peserta_selesai: number;
    count_pemateri_children: number;
    review_count: number;
    rata_rata_rating: number;
    count_review_excellent: number;
    count_review_verry_good: number;
    count_review_average: number;
    count_review_poor: number;
    count_review_terrible: number;
    count_peserta: number;
}

export class SertifikatPengetahuan {
    current_page: number;
    data: Data[];
    first_page_url: string;
    from: number;
    last_page: number;
    last_page_url: string;
    next_page_url: string | null;
    path: string;
    per_page: number;
    prev_page_url: string | null;
    to: number;
    total: number;
    constructor(
        current_page: number,
        data: Data[],
        first_page_url: string,
        from: number,
        last_page: number,
        last_page_url: string,
        next_page_url: string | null,
        path: string,
        per_page: number,
        prev_page_url: string | null,
        to: number,
        total: number
    ) {
        this.current_page = current_page;
        this.data = data;
        this.first_page_url = first_page_url;
        this.from = from;
        this.last_page = last_page;
        this.last_page_url = last_page_url;
        this.next_page_url = next_page_url;
        this.path = path;
        this.per_page = per_page;
        this.prev_page_url = prev_page_url;
        this.to = to;
        this.total = total;
    }
}